<template>
  <div>
    <b-row class="">
      <div class="d-flex flex-column">
        <h5>{{ $t("reference.category") }}</h5>
        <b-card no-body style="margin-top: 10px">
          <b-list-group
            class="cursor-pointer"
            style="overflow-y: scroll; height: 600px"
          >
            <b-list-group-item :style="styleObject" @click="resetAll()">
              {{ $t("reference.show_all") }}
            </b-list-group-item>

            <b-list-group-item
              v-for="item in product_categories.results"
              :key="item.id"
              class="flex flex-nowrap"
              :class="{ activeList: current === item.id }"
              @click="openTableId(item, item.id)"
            >
              <span>{{ item.title_full[$i18n.locale] }}</span>

              <b-dropdown
                id="dropdown-grouped"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-primary"
                class="dropdown-icon-wrapper"
                toggle-class="p-50"
                toggle-tag="span"
                size="sm"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle"
                  />
                </template>

                <b-dropdown-item
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  v-b-modal.modal-material-category-edit
                  @click="editCategory = item"
                >
                  <feather-icon
                    class="text-primary"
                    icon="EditIcon"
                    size="15"
                  />
                </b-dropdown-item>

                <b-dropdown-item @click="deleteCategory(item)">
                  <feather-icon
                    class="text-primary"
                    icon="TrashIcon"
                    size="15"
                  />
                </b-dropdown-item>
              </b-dropdown>
            </b-list-group-item>
          </b-list-group>

          <div class="d-flex align-items-center mt-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.modal-material-category-add
              size="sm"
              class="ml-auto"
              variant="outline-success"
              @click="editCategory = {}"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
          </div>
        </b-card>
      </div>

      <div class="d-flex flex-column mx-2" style="margin-top: 10px">
        <div class="d-flex justify-content-between align-items-center w-100">
          <AppSearchInput
            :label="$t('reference.vid_material') + ':'"
            :placeholder="$t('search')"
            @callback="searchMaterialType"
          />

          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="my-1 ml-4"
              variant="success"
              @click="saveXlsMaterialTypes"
            >
              <feather-icon icon="DownloadIcon" size="16" />
              {{ $t("download") }}
            </b-button>
            <b-button
              v-if="addButton"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.modal-material-type
              class="my-1 ml-1"
              variant="primary"
              @click="editTypeMaterial = {}"
            >
              <feather-icon icon="PlusIcon" size="16" />
              {{ $t("add") }}
            </b-button>
          </div>
        </div>

        <b-table
          v-if="!isLoading"
          selectable
          select-mode="single"
          class="border"
          :fields="fields"
          :items="GET_MATERIALS.results"
          responsive
          :empty-text="$t('empty_text')"
          show-empty
          hover
          :selected-variant="tableSelectable"
          @row-clicked="onRowSelected"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(title)="props">
            <span>{{ props.item.title_full[$i18n.locale] }}</span>
          </template>

          <template #cell(actions)="props">
            <div class="d-flex align-items-center">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-modal.modal-material-type
                size="sm"
                class="mt-50 mb-50"
                variant="warning"
                @click="editTypeMaterial = props.item"
              >
                <feather-icon icon="EditIcon" size="15" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="danger"
                class="ml-1 mt-50 mb-50"
                @click="deleteTableVidId(props)"
              >
                <feather-icon icon="TrashIcon" size="15" />
              </b-button>
            </div>
          </template>
        </b-table>

        <b-card v-else>
          <Loader />
        </b-card>

        <Pagination
          :rows="GET_MATERIALS.count"
          :params="paramsMaterialTypes"
          @refresh="refresh1()"
        />
      </div>

      <div class="d-flex flex-column" style="margin-top: 10px">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center mt-1 mr-4">
            <AppSearchInput
              :label="$t('reference.material') + ':'"
              :placeholder="$t('search')"
              @callback="searchMaterial"
            />

            <b-form-checkbox
              class="custom-control-success ml-2 d-flex align-items-center"
              name="check-button"
              switch
              v-model="generalSearch"
              @input="callSearchMaterial"
            />
            <span class="d-flex align-items-center mt-1">{{
              $t("general_search")
            }}</span>
          </div>
          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mt-1 ml-4"
              variant="success"
              @click="saveXlsMaterial"
            >
              <feather-icon icon="DownloadIcon" size="16" />
              {{ $t("download") }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.modal-material
              class="mt-1 ml-1"
              variant="primary"
              @click="editMaterials = {}"
            >
              <feather-icon icon="PlusIcon" size="16" />
              {{ $t("add") }}
            </b-button>
          </div>
        </div>

        <!-- selectable
          select-mode="single" -->
        <div>
          <b-table
            v-if="!isLoading2"
            class="border"
            :fields="fields"
            :items="GET_MATERIALS_TABLE_ID.results"
            responsive
            :empty-text="$t('empty_text')"
            show-empty
          >
            <!-- @row-clicked="onRowSelected2" -->
            <template #head()="props">
              <span>{{ $t(props.label) }}</span>
            </template>

            <template #cell(title)="props">
              <span>{{ props.item.value }}</span>
            </template>

            <template #cell(actions)="props">
              <div class="d-flex align-items-center">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  v-b-modal.modal-view-more-material
                  size="sm"
                  variant="success"
                  @click="viewMaterial = props.item"
                >
                  <feather-icon icon="EyeIcon" size="15" />
                </b-button>

                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  v-b-modal.modal-material
                  size="sm"
                  variant="warning"
                  class="ml-1"
                  @click="editMaterials = props.item"
                >
                  <feather-icon icon="EditIcon" size="15" />
                </b-button>

                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  class="ml-1"
                  size="sm"
                  variant="danger"
                  @click="deleteProduct(props)"
                >
                  <feather-icon icon="TrashIcon" size="15" />
                </b-button>
              </div>
            </template>
          </b-table>

          <b-card v-else>
            <Loader />
          </b-card>
        </div>

        <Pagination
          :rows="GET_MATERIALS_TABLE_ID.count"
          :params="paramsMaterial"
          @refresh="refresh2()"
        />
      </div>
    </b-row>

    <categoryAddModal />
    <categoryEditModal :editCategory="editCategory" />

    <materialModal :edit-materials="editMaterials" :category="product" />

    <materialViewModal :viewMaterial="viewMaterial" />

    <materialTypeModal :editTypeMaterial="editTypeMaterial" />
  </div>
</template>

<script>
/* eslint-disable */
import {
  BListGroup,
  BListGroupItem,
  BCard,
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BRow,
  BCol,
  BTable,
  BPagination,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters, mapState } from "vuex";
import AppSearchInput from "@/components/AppSearchInput.vue";
import materialModal from "./modals/materialModal.vue";
import materialViewModal from "./modals/materialViewModal.vue";
import materialTypeModal from "@/views/modules/Reference/materials/modals/materialTypeModal.vue";
import Pagination from "@/components/Pagination.vue";
import categoryAddModal from "./modals/categoryAddModal.vue";
import categoryEditModal from "./modals/categoryEditModal.vue";
import areYouSure from "@/mixins/areYouSure";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    BListGroup,
    BListGroupItem,
    BCard,
    BImg,

    BDropdown,
    BDropdownItem,

    BButton,
    BRow,
    BCol,
    BTable,
    Loader,

    AppSearchInput,
    materialModal,
    materialViewModal,
    Pagination,
    materialTypeModal,
    categoryAddModal,
    categoryEditModal,
    BPagination,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },

  mixins: [areYouSure],

  data() {
    return {
      isLoading: false,
      isLoading2: false,
      // ===============  PRIMARY_DATA_SECTION START ===============
      paramsMaterialTypes: {
        search: "",
        page_size: 10,
        page: 1,
      },
      paramsMaterial: {
        search: "",
        product: null,
        page_size: 10,
        page: 1,
      },
      secondTable: false,
      editMaterials: {},
      editTypeMaterial: {},
      viewMaterial: {},
      product: null,
      styleObject: {
        backgroundColor: "#5a9cd9",
        color: "#fff",
      },
      editCategory: {},
      current: null,
      addButton: false,
      category: null,
      generalSearch: true,
      tableSelectable: "active",

      fields: [
        {
          label: "№",
          key: "id",
        },
        {
          label: "reference.name",
          key: "title",
        },
        {
          label: "actions",
          key: "actions",
        },
      ],

      // ===============  PRIMARY_DATA_SECTION END ===============
    };
  },
  computed: {
    ...mapGetters("materials", ["GET_MATERIALS", "GET_MATERIALS_TABLE_ID"]),
    ...mapState("materials", ["product_categories"]),
  },
  async mounted() {
    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    this.isLoading = true;

    await this.FETCH_PRODUCT_CATEGORIES({ page_size: 1000 });
    await this.FETCH_CHARACTER();
    await this.refresh1();
    await this.refresh2();

    this.isLoading = false;
    // ===============  PRIMARY_REQUESTS_SECTION END ===============
  },
  methods: {
    ...mapActions("materials", [
      "FETCH_MATERIALS",
      "DELETE_MATERIALS",
      "FETCH_MATERIALS_TABLE_ID",
      "DELETE_MATERIALS_TABLE_ID",
      "FETCH_PRODUCT_CATEGORIES",
      "DELETE_PRODUCT_CATEGORY",
      "EXPORT_EXCEL_MATERIALS_TYPES",
      "EXPORT_EXCEL_MATERIALS",
    ]),
    ...mapActions("characterUnits", ["FETCH_CHARACTER"]),

    // ===============  REFRESH_SECTION START ===============
    async refresh1() {
      await this.FETCH_MATERIALS({
        ...this.paramsMaterialTypes,
        category: this.category,
      });
    },
    async refresh2() {
      await this.FETCH_MATERIALS_TABLE_ID({
        product: this.product,
        ...this.paramsMaterial,
      });
    },
    // ===============  REFRESH_SECTION END ===============

    // ===============  RESET_DATA_SECTION START ===============
    async resetAll() {
      this.isLoading = true;

      this.category = null;
      await this.refresh1();
      this.current = null;
      this.styleObject = {
        backgroundColor: "#5a9cd9",
        color: "#fff",
      };
      this.addButton = false;
      this.secondTable = false;
      this.isLoading = false;
    },
    // ===============  RESET_DATA_SECTION END ===============

    // ===============  SEARCH_SECTION START ===============
    async searchMaterialType(text) {
      this.isLoading = true;
      this.paramsMaterialTypes.search = text;
      await this.refresh1();
      this.isLoading = false;
    },
    async searchMaterial(text) {
      this.isLoading2 = true;

      if (
        this.paramsMaterial.product == null ||
        this.paramsMaterial.product == ""
      ) {
        this.$nextTick(() => {
          this.generalSearch = true;
        });
      }

      let params = {};
      this.paramsMaterial.search = text;

      params = this.paramsMaterial;
      if (this.generalSearch) {
        params.product = null;
      }

      await this.FETCH_MATERIALS_TABLE_ID(params);
      this.isLoading2 = false;
    },
    callSearchMaterial(value) {
      if (value) {
        this.tableSelectable = "";
      } else {
        this.tableSelectable = "active";
      }
      this.searchMaterial();
    },
    // ===============  SEARCH_SECTION END ===============

    // ===============  DELETE_SECTION START ===============
    deleteCategory(item) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.DELETE_PRODUCT_CATEGORY(item.id)
            .then(() => {
              this.FETCH_PRODUCT_CATEGORIES({ page_size: 1000 });
              // window.location.reload()
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    deleteProduct(props) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.DELETE_MATERIALS_TABLE_ID(props.item.id)
            .then(async () => {
              await this.FETCH_MATERIALS_TABLE_ID({
                product: this.product,
                page: 1,
                page_size: this.paramsMaterial.page_size,
              });
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    deleteTableVidId(props) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.DELETE_MATERIALS(props.item.id)
            .then(() => {
              this.FETCH_MATERIALS({
                ...this.paramsMaterialTypes,
                category: this.category,
              });
              this.secondTable = false;
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    // ===============  DELETE_SECTION END ===============

    // ===============  OTHERS_SECTION START ===============
    async onRowSelected(item) {
      this.isLoading2 = true;

      this.product = item.id;
      this.paramsMaterial.product = item.id;
      await this.FETCH_MATERIALS_TABLE_ID({
        product: this.product,
        page: 1,
        page_size: this.paramsMaterial.page_size,
      });
      this.secondTable = true;
      this.isLoading2 = false;
    },

    async openTableId(item, id) {
      this.isLoading = true;
      this.current = id;
      this.category = id;
      this.$route.params.category_id = id;
      await this.refresh1();

      this.styleObject = {
        backgroundColor: null,
        color: null,
      };

      this.addButton = true;
      this.secondTable = false;
      this.isLoading = false;
    },
    async saveXlsMaterialTypes() {
      this.EXPORT_EXCEL_MATERIAL_TYPES({
        category: this.category,
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "material-types.xls");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          this.$_errToast("Error");
        });
    },
    async saveXlsMaterial() {
      this.EXPORT_EXCEL_MATERIALS({
        product: this.product,
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "materials.xls");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          this.$_errToast("Error");
        });
    },
    // ===============  OTHERS_SECTION END ===============
  },
};
</script>

<style>
.table-materials .table.b-table > tbody > .table-active,
[dir] .table.b-table > tbody > .table-active > th,
[dir] .table.b-table > tbody > .table-active > td {
  color: #fff;
  background-color: #5a9cd9 !important;
}

.activeList {
  background: #5a9cd9 !important;
  color: #fff !important;
}

.activeList svg:nth-child(1) {
  color: #fff;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.flex span {
  width: 69%;
  text-align: left;
  user-select: none;
}

.mt-25px {
  margin-top: 25px;
}

.pagination-square .page-item,
.pagination-square .page-item .page-link {
  border-radius: 0 !important;
}
</style>
